import React from 'react';
import { Divider, Typography } from '@ui';
import { Col, Flex, Form, Row, Switch } from 'antd';
import { StyledIconSlot } from './styled';

/**
 * Card header: brand icon + title on the left, on/off switch on the right. The icon is greyed and the divider hidden while the switch is off.
 * @param {object} props
 * @param {React.ReactNode} props.icon
 * @param {string} props.title
 * @param {string} props.fieldName Form field bound to the switch.
 * @param {string} props.titleE2e
 * @param {string} props.toggleE2e
 */
const SectionHeader = ({ icon, title, fieldName, titleE2e, toggleE2e }) => {
    const enabled = Form.useWatch(fieldName, Form.useFormInstance());

    return (
        <React.Fragment>
            <Row justify='space-between' align='middle'>
                <Col>
                    <Flex align='center' gap={16}>
                        <StyledIconSlot $disabled={!enabled}>{icon}</StyledIconSlot>
                        <Typography.Title data-e2e={titleE2e} level={2}>
                            {title}
                        </Typography.Title>
                    </Flex>
                </Col>
                <Col>
                    <Form.Item name={fieldName} valuePropName='checked'>
                        <Switch data-e2e={toggleE2e} aria-label={title} />
                    </Form.Item>
                </Col>
            </Row>
            {enabled && <Divider margin='24px 0' />}
        </React.Fragment>
    );
};

export default SectionHeader;
